module.exports = __webpack_public_path__ + "img/symbol_0.bbc779b5.png";